export default "__VITE_ASSET__DtZhToQw__"